import React from 'react';
import { Button, Typography } from '@navi/web-ui/lib/primitives';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';

interface ConfigDrawerFooterProps {
  isEditable: boolean;
  isOutsideClick: boolean;
  onCancel: () => void;
  onSave: () => void;
  onExitYes: () => void;
  onExitNo: () => void;
}

const ConfigDrawerFooter: React.FC<ConfigDrawerFooterProps> = ({
  isEditable,
  isOutsideClick,
  onCancel,
  onSave,
  onExitYes,
  onExitNo
}) => {
  if (!isEditable) {
    return null;
  }

  if (!isOutsideClick) {
    return (
      <div className="p-4">
        <Button variant="secondary" onClick={onCancel} size="medium" className="w-[150px] mr-4">
          Cancel
        </Button>
        <Button
          variant="primary"
          type="submit"
          size="medium"
          onClick={onSave}
          className="w-[150px]"
          disabled={!isEditable}
        >
          Save changes
        </Button>
      </div>
    );
  }

  return (
    <div className={'flex p-4 !bg-[var(--navi-color-red-bg)]'}>
      <div className="w-[20px] pt-[2px] mr-2">
        <ErrorIconOutline />
      </div>
      <div>
        <div className="items-center">
          <Typography variant="h5" color="var(--navi-color-red-base)">
            Your changes will not be saved. Are you sure you want to exit?
          </Typography>
        </div>
        <div className="mt-2">
          <Button variant="secondary" size="small" className="mr-4" onClick={onExitYes}>
            Yes
          </Button>
          <Button variant="primary" type="submit" size="small" onClick={onExitNo}>
            No
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfigDrawerFooter;
